import React from "react";
import { useConfig } from "../../data/useConfig";
import ItemSkeleton from "./ItemSkeleton";
import { ResultsSkeletonContainer } from "./styles";

const ResultsSkeleton = ({ data }) => {
  const { filterDirection } = useConfig();

  const areThereFilters = !!(
    data?.meta?.filters_available &&
    Object.keys(data.meta.filters_available).length
  );

  return (
    <ResultsSkeletonContainer
      className="bnly-results-skeleton-container"
      horizontal={filterDirection === "horizontal"}
      areThereFilters={areThereFilters}
    >
      <ItemSkeleton />
    </ResultsSkeletonContainer>
  );
};

export default ResultsSkeleton;
